import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Anthem Blue Cross and Blue Shield of Georgia",
  shortName: "Anthem BCBS Georgia",
  slug: "anthem-bcbs-ga-insurance",
  seoTitle:
    "Anthem Blue Cross and Blue Shield of Georgia TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Anthem Blue Cross and Blue Shield of Georgia policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Anthem BCBS Georgia TMS coverage, Anthem Georgia SPRAVATO authorization, Anthem BCBS Georgia mental health benefits Coral Springs FL, Anthem Georgia depression treatment Florida",
};

export const AnthemBcbsGaInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AnthemBcbsGaInsurance;
